import { exceptionToString } from "../common/Support";
import { isRight } from "fp-ts/lib/Either";
import * as t from "io-ts";

const dbCleanupMessageCodec = t.type({
    kind: t.literal("glide-sw-db-cleanup"),
});
export type DbCleanupMessage = t.TypeOf<typeof dbCleanupMessageCodec>;
export function isDbCleanupMessage(m: unknown): m is DbCleanupMessage {
    return isRight(dbCleanupMessageCodec.decode(m));
}
export function makeDbCleanupMessage(): DbCleanupMessage {
    return {
        kind: "glide-sw-db-cleanup",
    };
}

const cacheCleanupMessageCodec = t.type({
    kind: t.literal("glide-sw-cache-cleanup"),
});
export type CacheCleanupMessage = t.TypeOf<typeof cacheCleanupMessageCodec>;
export function isCacheCleanupMessage(m: unknown): m is CacheCleanupMessage {
    return isRight(cacheCleanupMessageCodec.decode(m));
}
export function makeCacheCleanupMessage(): CacheCleanupMessage {
    return {
        kind: "glide-sw-cache-cleanup",
    };
}

const swErrorMessageCodec = t.type({
    kind: t.literal("glide-sw-error"),
    action: t.string,
    exceptionStr: t.string,
    exception: t.unknown,
});
export type ServiceWorkerErrorMessage = t.TypeOf<typeof swErrorMessageCodec>;
export function isServiceWorkerErrorMessage(m: unknown): m is ServiceWorkerErrorMessage {
    return isRight(swErrorMessageCodec.decode(m));
}
export function makeServiceWorkerErrorMessage(action: string, e: unknown): ServiceWorkerErrorMessage {
    return {
        kind: "glide-sw-error",
        action,
        exceptionStr: exceptionToString(e),
        exception: e,
    };
}
